import React from "react";

const PrintFooter = (props) => {
  const email = props.email;
  const phone = props.phone;

  return (
    <div
      style={{
        left: "0",
        bottom: "0px",
        width: "100%",
        position: "fixed",
      }}
    >
      <hr
        style={{
          border: "1px solid #13222d",
          borderRadius: "1px",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <h6>© Drakryggen AB </h6>

        <h6>{email ? email : <br />}</h6>

        <h6>{phone ? phone : <br />}</h6>

        <h6>www.drakryggen.com</h6>
      </div>
    </div>
  );
};

export default PrintFooter;
